export default "__VITE_ASSET__b31615ed__"